/* "Auf dem Handy kuerzen": drei Zeilen und ein Knopf "mehr lesen".
 *
 * Der Knopf erscheint nur, wenn wirklich etwas abgeschnitten ist - im alten Theme stand er
 * auch unter kurzen Texten. Gemessen wird scrollHeight gegen clientHeight.
 *
 * Seit 18.09.2026 (Muster wie Fiete im Gruenderblock, c07b27d/1f7899a): erst ALLE Absaetze lesen,
 * dann alle Knoepfe schreiben, und gemessen wird im ResizeObserver, also nach dem Layout. Vorher
 * las jeder Absatz im eigenen requestAnimationFrame und schrieb sofort - Lesen, Schreiben, Lesen
 * erzwang je Absatz ein Layout der ganzen Seite (92 ms beim Laden der Kollektion, CPU x 4).
 * Die gekuerzte Box behaelt ihre Hoehe, wenn nur die Schrift wechselt - das meldet kein
 * ResizeObserver, deshalb zusaetzlich nach "load" und fonts.ready (gebuendelt in einem Bild).
 *
 * Seit 26.09.2026: bei langem Text kommt der Knopf ohne hidden und mit "ist-vorab" - dann steht er am Handy schon
 * vor dem Messen (am Desktop verbirgt ihn mhsys-weissblau.css), sonst schob er die Seite spaet nach unten
 * (Layout-Verschiebung). Die erste Messung setzt hidden richtig und nimmt die Klasse weg.
 */
(() => {
  'use strict';

  const eintraege = [];

  function pruefen() {
    const ergebnis = eintraege.map(({ absatz }) =>
      absatz.classList.contains('is-offen') ? null : absatz.scrollHeight <= absatz.clientHeight + 2
    );
    eintraege.forEach(({ knopf }, i) => {
      if (ergebnis[i] === null) return;
      if (knopf.hidden !== ergebnis[i]) knopf.hidden = ergebnis[i];
      /* ab jetzt gilt das Messergebnis, nicht mehr die Schaetzung des Servers (ist-vorab) */
      knopf.classList.remove('ist-vorab');
    });
  }

  let geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(() =>
      setTimeout(() => {
        geplant = false;
        pruefen();
      }, 0)
    );
  }

  /* Seit 05.10.2026: neu gemessen wird nur beim ersten Melden und wenn sich die Breite wirklich aendert.
     Eine reine Hoehenaenderung (z. B. beim Sperren des Scrollens fuer die Schublade) loeste sonst eine
     Messung samt Schreiben aus, die das Layout ein zweites Mal anstiess. Schriftwechsel faengt planen() ab. */
  const breiten = new WeakMap();
  const beobachter =
    'ResizeObserver' in window
      ? new ResizeObserver((meldungen) => {
          let geaendert = false;
          meldungen.forEach(({ target, contentRect }) => {
            const breite = Math.round(contentRect.width);
            if (breiten.get(target) === breite) return;
            breiten.set(target, breite);
            geaendert = true;
          });
          if (geaendert) pruefen();
        })
      : null;

  function verbinden(absatz) {
    if (absatz.dataset.mhsysBereit) return;
    absatz.dataset.mhsysBereit = '1';
    const knopf = absatz.parentElement.querySelector('[data-mhsys-kuerzen-knopf]');
    if (!knopf) return;
    eintraege.push({ absatz, knopf });

    knopf.addEventListener('click', () => {
      absatz.classList.add('is-offen');
      knopf.hidden = true;
    });

    if (beobachter) beobachter.observe(absatz);
  }

  function starten() {
    document.querySelectorAll('[data-mhsys-kuerzen]').forEach(verbinden);
    if (!beobachter) planen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  document.addEventListener('shopify:section:load', starten);
  window.addEventListener('load', planen, { once: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(planen);
  if (!beobachter) window.addEventListener('resize', planen, { passive: true });
})();
